/* eslint-disable camelcase */

import { ExamCenter } from './examCenter';

/**
 * Demande de tickets réglée par la facture, vue depuis la facture.
 * Défini ici et non dans `voucherRequest.ts` : ce module-là importe déjà
 * `Invoice`, la dépendance inverse créerait un cycle.
 */
export class InvoiceVoucherRequest {
    id: number;
    quantity: number;
    created_date: Date;

    constructor(data: any) {
        if (data) {
            this.id = data.id;
            this.quantity = data.quantity;
            if (data.created_date) this.created_date = new Date(data.created_date);
        }
    }
}

export class Invoice {
    id: number;
    label: string;
    date: Date;
    document: string; // Should be an URL on get, but a file when posting/putting the invoice
    center: ExamCenter;
    // Une facture peut répondre à plusieurs demandes (FK côté demande).
    voucher_requests: Array<InvoiceVoucherRequest> = [];

    constructor(data: any) {
        if (data) {
            this.id = data.id;
            this.label = data.label;
            this.document = data.document;
            if (data.date) this.date = new Date(data.date);
            if (data.center) this.center = new ExamCenter(data.center);
            if (data.voucher_requests) {
                this.voucher_requests = data.voucher_requests.map(
                    (request: any) => new InvoiceVoucherRequest(request)
                );
            }
        }
    }
}
